import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import it from "./locales/it.json";
import en from "./locales/en.json";

const stored = typeof window !== "undefined" ? localStorage.getItem("hopzigo_lang") : null;

i18n.use(initReactI18next).init({
  resources: {
    it: { translation: it },
    en: { translation: en },
  },
  lng: stored || "it",
  fallbackLng: "it",
  interpolation: { escapeValue: false },
});

export function setLang(lng) {
  i18n.changeLanguage(lng);
  try { localStorage.setItem("hopzigo_lang", lng); } catch { /* ignore */ }
}

export default i18n;
